<template>
    <div>
        <transition name="component-fade" mode="out-in">
            <div class="columns is-mobile">
                <div class="column is-12">
                    <form @submit.prevent="send">

                        <div class=" m-t-md">

                            <div class="card-content">
                                <div class="content">
                                    <div class="field is-horizontal">
                                        <div class="field-body">
                                            <div class="field">
                                                <b-field :label="$t('candidate.contact.gender.label')">
                                                    <b-select v-model="account.gender" required>
                                                        <option value="F">Madame</option>
                                                        <option value="M">Monsieur</option>
                                                    </b-select>
                                                </b-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field is-horizontal">
                                        <div class="field-body">
                                            <div class="field is-horizontal">
                                                <p class="control is-expanded">
                                                    <b-field :label="$t('candidate.contact.last_name')" class="has-text-left">
                                                        <b-input v-model="account.last_name"
                                                                 minlength="1"
                                                                 required>

                                                        </b-input>
                                                    </b-field>
                                                </p>
                                            </div>
                                            <div class="field">
                                                <p class="control is-expanded">
                                                    <b-field :label="$t('candidate.contact.first_name')" class="has-text-left">
                                                        <b-input v-model="account.first_name"
                                                                 minlength="1"
                                                                 required>

                                                        </b-input>
                                                    </b-field>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field is-horizontal">
                                        <div class="field-body">
                                            <div class="field is-horizontal">
                                                <p class="control is-expanded">
                                                    <b-field :label="$t('contact.form.child_last_name')" class="has-text-left">
                                                        <b-input v-model="account.child.last_name"
                                                                 minlength="1"
                                                                 required>
                                                        </b-input>
                                                    </b-field>
                                                </p>
                                            </div>
                                            <div class="field">
                                                <p class="control is-expanded">
                                                    <b-field :label="$t('contact.form.child_first_name')" class="has-text-left">
                                                        <b-input v-model="account.child.first_name"
                                                                 minlength="1"
                                                                 required>
                                                        </b-input>
                                                    </b-field>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field is-horizontal">
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded">
                                                    <b-field :label="$t('connection.email')">
                                                        <b-input type="email"
                                                                 name="email"
                                                                 ref="email"
                                                                 :data-vv-as="$t('connection.email')"
                                                                 v-model="account.email"
                                                                 v-validate="'required'">
                                                        </b-input>
                                                    </b-field>
                                                </p>
                                            </div>
                                            <div class="field">
                                              <div class="control">
                                                <label class="label" v-bind:class="[ errors.has('phone') ? 'has-text-danger' : '']">
                                                  {{ $t('candidate.contact.phone') }}</label>

                                                <VuePhoneNumberInput v-model="account.phone"
                                                                     :required="true"
                                                                     :border-radius="0"
                                                                     color="firebrick"
                                                                     :preferred-countries="['FR']"
                                                                     @update="updateCandidatePhone"
                                                                     :translations="{
                                                        countrySelectorLabel: 'Code pays',
                                                        countrySelectorError: 'Choisir un pays',
                                                        phoneNumberLabel: 'Numéro de téléphone',
                                                        example: 'Exemple :'
                                                      }"
                                                />
                                              </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field is-horizontal">
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded">
                                                    <b-field :label="$t('candidate.contact.address')"
                                                             class="has-text-left">
                                                        <b-input v-model="account.address"
                                                                 required>

                                                        </b-input>
                                                    </b-field>
                                                </p>
                                            </div>
                                            <div class="field">
                                                <p class="control is-expanded">
                                                    <b-field :label="$t('candidate.contact.address_complement')"
                                                             class="has-text-left">
                                                        <b-input v-model="account.address_complement">
                                                        </b-input>
                                                    </b-field>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field is-horizontal">
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded">
                                                    <b-field :label="$t('candidate.contact.post_code')"
                                                             class="has-text-left">
                                                        <b-input v-model="account.post_code"
                                                                 required>

                                                        </b-input>
                                                    </b-field>
                                                </p>
                                            </div>
                                            <div class="field">
                                                <p class="control is-expanded">
                                                    <b-field :label="$t('candidate.contact.city')"
                                                             class="has-text-left">
                                                        <b-input v-model="account.city"
                                                                 required>
                                                        </b-input>
                                                    </b-field>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field is-horizontal">
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded">
                                                    <b-field :label="$t('candidate.contact.country')"
                                                             class="has-text-left">
                                                        <b-select v-model="account.country" required>
                                                            <option value="">---</option>

                                                            <option
                                                                    v-for="country in countries"
                                                                    :value="country['alpha-2']"
                                                            >
                                                                {{ country.country }}
                                                            </option>
                                                        </b-select>
                                                    </b-field>
                                                </p>
                                            </div>

                                        </div>

                                </div>
                                    <div class="field is-horizontal">
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded">
                                                    <b-field :label="$t('candidate.messages.message')">

                                                        <b-input type="textarea"
                                                                 required
                                                                 name="message"
                                                                 v-model="account.message"></b-input>
                                                    </b-field>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            </div>

                        </div>

                        <hr>
                        <div class="has-text-centered">
                            <button :class="'is-large button-valid button ' + isLoading">
                                {{ $t('labels.general.send') }}
                            </button>
                            <br>
                            <br>
                            <transition name="slide-fade">
                                <div class="has-text-danger has-text-centered">{{ errorMsg }}</div>
                            </transition>
                        </div>

                    </form>
                </div>
            </div>

        </transition>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import Cleave from 'cleave.js'
    import CountriesFR from '../../utils/countries_fr.json'
    import services from 'services/candidate'
    import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'

    const cleave = {
        name: 'cleave',
        bind (el, binding) {
            const input = el.querySelector('input')
            input._vCleave = new Cleave(input, binding.value)
        },
        update (el, binding) {
            const input = el.querySelector('input')
            input._vCleave.destroy()
            input._vCleave = new Cleave(input, binding.value)
        },
        unbind (el) {
            const input = el.querySelector('input')
            input._vCleave.destroy()
        }
    }

    export default {
        directives: { cleave },
      components: {
        VuePhoneNumberInput
      },
        data () {
            return {
                errorMsg:'',
                isLoading: '',
                account: {
                    gender: '',
                    first_name: '',
                    last_name: '',
                    child: {
                      first_name: null,
                      last_name: null
                    },
                    choices: null,
                    email: '',
                    phone: '',
                    phone_code: '',
                    address: '',
                    address_complement: '',
                    post_code: '',
                    city: '',
                    country: '',
                    message: '',
                },
                countries: null,
                error: '',
                existingMail: false
            }
        },
        computed: {
            ...mapState({
                user: 'auth'
            }),
            school () {
                return this.$route.params.school
            }
        },
        methods: {
            ...mapActions('auth', [
                    'shopRegister'
                ]
            ),
            toggleLoading: function () {
                this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
            },
            showLogin () {
                this.$emit('login')
            },
            showForgetPassword () {
                this.$emit('forgetPassword')
            },
          updateCandidatePhone(phone) {
            if (this.account.phone && !phone.isValid) {
              this.error = "Attention votre numéro de téléphone ne semble pas valide"
            } else {
              this.error = null
            }
            this.account.phone_code = phone.countryCode
          },
            send () {
                this.$validator.validateAll().then((valid) => {

                    if (valid) {
                        this.toggleLoading()
                        this.account.school_slug = this.school
                        services.contactRequest(this.account).then((result) => {
                            this.toggleLoading()
                            if (result.status) {
                                switch (result.status) {
                                    case 200:
                                        this.$emit('sent')
                                        break
                                    case 422:
                                        this.$emit('registered')
                                        break
                                }
                            }

                            if (result.status_code) {
                                switch (result.status) {
                                    case 200:
                                        this.$emit('sent')
                                        break
                                    case 422:
                                        this.$emit('registered')
                                        break
                                }
                            }

                        }).catch(() => {
                            this.toggleLoading()
                        })
                    }

                })

            }
        },
        created() {
            this.countries = CountriesFR
        }
    }
</script>

<style scoped>
    .phone-code {
        margin-bottom: 18px;
    }
    .notification.is-warning {
        margin-top: 6px;
        text-align: center;
    }

    .connexion-switch {
        height: 4rem;
    }
</style>
